export const adaptKetosteril = (ketosterilRIByDatosGeneralesId) => {
    const { ketosterilRI, laboratorioAdjunto} = ketosterilRIByDatosGeneralesId?.ketosterilRIByDatosGeneralesId || {};
    delete laboratorioAdjunto.__typename;
    return {
        ketosteril1: {
            idKetosterilRI: ketosterilRI?.idKetosterilRI,
            idDatosGeneralesRI: ketosterilRI?.idDatosGeneralesRI,
            idComboRIValorERCestadio: ketosterilRI?.idComboRIValorERCestadio,
            laboratorio: ketosterilRI?.laboratorio,
            fG: ketosterilRI?.fG,
            recuperacionRenalDialisis: ketosterilRI?.recuperacionRenalDialisis,
            txrenalConDeterioro: ketosterilRI?.txrenalConDeterioro,
            quiereDialisis: ketosterilRI?.quiereDialisis,
            hemodialisisIncremental: ketosterilRI?.hemodialisisIncremental,
            laboratorioAdjunto: laboratorioAdjunto
        }
    }
}

export const adaptKetosterilArray = (
    ketos
) => {
    return structuredClone(ketos?.allKetosterilRI)
        ?.map(keto => adaptKetosteril(keto));
}